import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';

import { Card, CardHeader, CardContent, Avatar, ForgeIcon } from './ui';
import formatProductName from '../utils/formatProductName';

const MessageContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    padding: theme.spacing(1),
    [theme.breakpoints.down('lg')]: {
        marginLeft: 0,
        padding: theme.spacing(1),
    },
}));

const ChatWarning = ({ warningMessage, product }) => {
    const displayProduct = formatProductName(product);

    return (
        <MessageContainer aria-live='polite'>
            <Card
                className="mt-6"
                sx={{
                    borderLeft: '4px solid #E20000',
                    boxShadow: '0 2px 16px rgba(51,0,0,0.08)',
                    borderRadius: '0 8px 8px 0',
                }}
            >
                <CardHeader
                    avatar={<Avatar icon={<ForgeIcon />} size="sm" />}
                    subtitle={`HelpBot • ${displayProduct}`}
                    title="HelpBot"
                    titleVariant="default"
                    sx={{
                        borderBottom: '1px solid rgba(0,0,0,0.08)',
                        '& .MuiCardHeader-title': { fontWeight: 600, color: '#330000' },
                        '& .MuiCardHeader-subheader': { fontSize: '0.75rem' },
                    }}
                />
                <CardContent top="none">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#b00020' }}>
                        <Typography variant="body2">{warningMessage}</Typography>
                    </Box>
                </CardContent>
            </Card>
        </MessageContainer>
    );
};

export default ChatWarning;
